<div class="navbar bg-base-100 min-h-20 rounded-xl px-4">
  <div class="flex-none">
    <a
      class="btn btn-ghost text-primary h-14 text-xl lg:h-18"
      [routerLink]="['/']"
    >
      <img src="/assets/logo/logo-small.png" class="h-14 lg:h-16" />
      <span class="mt-1 hidden md:block">
        {{ "common.title" | translate }}
      </span>
    </a>
  </div>
  <div class="flex-1 justify-items-end">
    <p class="mx-4 hidden text-neutral-600 md:block">
      {{ "navigation.navbar.welcome" | translate: { fullName } }}
    </p>
  </div>
  <div class="flex-none">
    <div class="dropdown dropdown-end dropdown-hover">
      <div
        tabindex="0"
        class="avatar placeholder btn btn-circle btn-ghost"
        role="button"
      >
        <div class="bg-accent text-base-100 rounded-full">
          <span class="text-3xl">{{ userInitials }}</span>
        </div>
      </div>
      <div
        tabindex="0"
        class="card dropdown-content card-compact bg-base-100 text-base-content z-[1] min-w-32 rounded-lg p-2 shadow"
      >
        <div class="card-body items-center">
          @if (fullName) {
            <span class="truncate">{{ fullName }}</span>
          }
          <app-logout></app-logout>
        </div>
      </div>
    </div>
  </div>
</div>
